export default function Disabled (props) {
  return "disabled action";
}
